// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Shared imports
const BemEntity = require('shared/bem')
const { formatCount, pluralize } = require('shared/string-utils')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const SimpleNav = require('client-v2/common/components/simple-nav')
// Container imports
const collectionActions = require('../collection/actions')
// URL helpers
const {
  collectionProfileSubscribersHref,
  collectionProfilePostsHref
} = collectionActions

const bemEntity = BemEntity('CollectionProfileNavLinks')

const Posts = pluralize('Post')
const Subscribers = pluralize('Subscriber')

function mapStateToProps() {
  const itemsSelector = createItemsSelector()
  return function (state) {
    return {
      bemEntity,
      itemsSelector,
      collection: state.collection,
      selectedItemId: selectedState(state)
    }
  }
}

const mapDispatchToProps = {
  onPostsClick: collectionActions.navigateToCollectionProfilePosts,
  onSubscribersClick: collectionActions.navigateToCollectionProfileSubscribers
}

function mergeProps(stateProps, dispatchProps, ownProps) {
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    items: stateProps.itemsSelector(stateProps, dispatchProps)
  })
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(
  withImmutableToJS(
    SimpleNav
  )
)

// State helpers

function createItemsSelector() {
  return createSelector(
    [
      (stateProps) => stateProps.collection,
      (stateProps, dispatchProps) => dispatchProps
    ],
    (collection, dispatchProps) => {
      const postCount = collection['posts_count']
      const subscriberCount = collection['follower_count']
      return [
        {
          id: 'posts',
          label: renderLabel(postCount, Posts),
          href: collectionProfilePostsHref(collection),
          title: `${postCount} ${Posts(postCount)}`,
          onClick: event => dispatchProps.onPostsClick({ event, collection })
        },
        {
          id: 'subscribers',
          label: renderLabel(subscriberCount, Subscribers),
          href: collectionProfileSubscribersHref(collection),
          title: `${subscriberCount} ${Subscribers(subscriberCount)}`,
          onClick: event => dispatchProps.onSubscribersClick({ event, collection })
        }
      ]
    }
  )
}

function renderLabel(count, pluralizedFn) {
  return tag([
    tag('span', {
      className: bemEntity.element('count')
    },
      // Trailing space is for screen-readers
      `${formatCount(count)} `
    ),
    tag('span', {
      className: bemEntity.element('text')
    },
      pluralizedFn(count)
    )
  ])
}

function selectedState(state) {
  switch (state.router.action) {
    case 'collection-profile.showPosts':
      return 'posts'
    case 'collection-profile.showSubscribers':
      return 'subscribers'
    default:
      return null
  }
}
